import { env } from '../../util/env';

const { MEGATRON_HOST } = env;

export type WhiteLabelEntityType = 'practice' | 'group' | 'feedback' | 'booking';

export const buildThemeParamUrl = (
  id: string,
  entity: WhiteLabelEntityType,
  hostname?: string | null,
) => `${hostname ?? MEGATRON_HOST}/api/4/themes/${entity}/${id}`;
